import React from 'react';
import makeStyles from '@material-ui/core/styles/makeStyles';
import createStyles from '@material-ui/core/styles/createStyles';
import TextField from '@material-ui/core/TextField';
import FieldContainer from './FieldContainer';

const useStyles = makeStyles((theme) =>
  createStyles({
    textField: {
      background: 'white',
    },
    textFieldInput: {
      fontSize: 15,
      [theme.breakpoints.down('xs')]: {
        fontSize: 16,
      },
    },
    floatingLabelFocusStyle: {
      color: '#8b8b8b',
      '&.shrink': {
        transform: 'translate(18px, 0px) scale(0.75)',
      },
    },
  }),
);

const Textarea: React.FC<any> = ({ label, type, name, errorText, inputRef, defaultValue, value, onChange }) => {
  const classes = useStyles();
  return (
    <FieldContainer errorText={errorText}>
      <TextField
        label={label}
        InputLabelProps={{
          style: { fontSize: 15, margin: -5 },
          classes: {
            root: classes.floatingLabelFocusStyle,
            focused: 'focused',
            shrink: 'shrink',
          },
        }}
        InputProps={{ classes: { input: classes.textFieldInput } }}
        className={classes.textField}
        type={type}
        name={name}
        margin="dense"
        variant="outlined"
        multiline
        rows={6}
        rowsMax={6}
        error={!!errorText}
        inputRef={inputRef}
        defaultValue={defaultValue}
        value={value}
        onChange={onChange}
      />
    </FieldContainer>
  );
};

export default Textarea;
